export const DYNAMIC_CLIENT_WIDTH = 1600
